import { css } from '@emotion/css'
import { fontSize, fontWeight, fontFamily } from '../../styles'
import getThemeColors, { colors } from '../../themes'
import { hexToRgba } from '../../themes/helpers'

const styles = {
  counter: css({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.semiBold,
    lineHeight: 1.2,
    borderRadius: '50%',
  }),

  clickable: css({
    cursor: 'pointer',
  }),
}

export default styles

export const counterSize = size => {
  switch (size) {
    case 'medium':
      return css({
        width: 24,
        height: 24,
        fontSize: fontSize.small,
      })

    default:
      return css({
        width: 20,
        height: 20,
        fontSize: fontSize.extraSmall,
      })
  }
}

export const counterTheme = (theme, clickable, mode = 'light') => {
  const themed = getThemeColors(theme)
  const accentColor = mode === 'light' ? themed.base : themed.medium
  let backgroundColor
  let color

  switch (mode) {
    case 'dark':
      backgroundColor = themed.base
      color = colors.white
      break
    default:
      backgroundColor = themed.light
      color = theme === 'light' ? colors.jumbo : themed.base
  }

  return css({
    backgroundColor,
    color,

    ...(clickable && {
      '&:hover': {
        backgroundColor: accentColor,
        color: colors.white,
      },

      '&:focus': {
        outline: 'none',
        boxShadow: `0 0 2px 2px ${hexToRgba(accentColor, 0.3)}`,
        backgroundColor: accentColor,
        color: colors.white,
      },
    }),
  })
}
